import $ from 'jquery';

let accordion = $('#accordion');
let collaps = $(accordion).find('.collapse');

$(collaps).on('show.bs.collapse', function () {
    addOrRemoveClassToCollapseButton($(this), true);
})

$(collaps).on('shown.bs.collapse', function () {
    let target = $('#' + $(this).attr('aria-labelledby'));
    if ( target.size() !== 1 )
        return null;

    $([document.documentElement, document.body]).animate({
        scrollTop: $(target).offset().top - 15
    }, 0);
})

$(collaps).on('hide.bs.collapse', function () {
    addOrRemoveClassToCollapseButton($(this), false);
})

function addOrRemoveClassToCollapseButton (element, display = 0) {
    let target = $('#' + element.attr('aria-labelledby'));
    if ( target.size() !== 1 )
        return null;

    if (display){
        target.addClass('show');
    } else {
        target.removeClass('show');
    }
}